import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IItemsTableOptions } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/data-source/data-source-items/interfaces/items-table-options.interface';
import { FiltersChannel } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/filters/models/filters-channel.model';
import { TableComponent } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tables/components/table/table.component';
import { IFilters } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filters.interface';
import { ITableDataSource } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table-data-source.interface';
import { ITablePagination } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table/table-pagination.interface';
import { ITableSort } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table/table-sort.interface';
import { SessionService } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/services/session.service';
import { valueModeLabelMap } from '@backend/features/export/export.interface';
import { omit } from 'lodash';
import { ExportTableService } from '../../export-table.service';
import { ExportService } from '../../export.service';
import { IExport } from '../../interface/export.interface';

@Component({
  selector: 'app-export-table',
  templateUrl: './export-table.component.html',
  styleUrls: ['./export-table.component.scss'],
})
export class ExportTableComponent extends TableComponent<IExport, string> {
  readonly headings = ['runNumber', 'mode', 'id', 'status', 'download', 'createdAt', 'finishedAt'];

  @Input() filtersChannel?: FiltersChannel;
  @Input() options: IItemsTableOptions;
  @Input() dontCache = false;
  @Input() tableAlias: string;
  @Output() rowSelected = new EventEmitter<IExport>();

  pageSize = this.options?.defaultPageSize || 15;
  canSort = false;

  constructor(
    sessionService: SessionService,
    private readonly exportService: ExportService,
    private readonly exportTableService: ExportTableService,
  ) {
    super(sessionService);
  }

  async download(item: { _id: string; isDownloading?: true }, event?: MouseEvent) {
    event?.stopPropagation();
    item.isDownloading = true;
    await this.exportService.download(item);
    delete item.isDownloading;
  }

  protected getPaginated(
    filters: IFilters,
    sort: ITableSort,
    pagination: ITablePagination,
    search: string,
  ): Promise<ITableDataSource<IExport>> {
    return this.exportTableService.getPaginated('', {
      filters,
      sort,
      pagination,
      search,
    });
  }

  formatExportStatus(exportItem: IExport): string {
    let status = exportItem.status;

    if (status === 'STARTING') {
      status = 'RUNNING';
    }

    if (status != 'COMPLETED' && new Date(exportItem.createdAt).getTime() + 24 * 60 * 60 * 1000 < Date.now()) {
      status = `Stale with (${status})`;
    }

    return status;
  }

  formatExportMode(exportItem: IExport): string {
    const valueMode = exportItem.filter?.valueMode;

    return valueMode ? valueModeLabelMap[valueMode] : 'Unknown';
  }

  cleanFilterObject(filter) {
    return omit(filter ?? {}, '_id');
  }

  rowClick(item) {
    this.rowSelected.emit(item);
  }
}
